/**
 * @author Code Lai（赖传峰）
 * @email codelai@staritgp.com
 * @date 2018/3/22 19:40
 */
import { Button, Col, Row } from 'antd'
import { memo } from 'react'
import { Link } from 'react-router-dom'

export default memo(() => {
  const reg = /^(\/(?:en|cn)\/(?:admin|shop)?).*$/i
  const link = location.pathname.replace(reg, '$1')
  return (
    <div
      style={{
        marginTop: 16,
        background: '#fff',
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
      }}
    >
      <Row>
        <Col span={12}>
          <div
            style={{
              height: 660,
              background: `url(${require('../../img/404.svg')}) right no-repeat`,
            }}
          />
        </Col>
        <Col
          span={8}
          offset={2}
        >
          <div style={{ marginTop: 200 }}>
            <h1
              style={{
                fontWeight: 'normal',
                fontSize: 72,
                marginBottom: 8,
              }}
            >
              SORRY
            </h1>
            <div
              style={{
                color: 'rgba(0, 0, 0, .45)',
                fontSize: 30,
                marginBottom: 16,
              }}
            >{__('we couldn\'t find that page')}
            </div>
            <Link to={link}>
              <Button type='primary'>{__('Back Home')}</Button>
            </Link>
          </div>
        </Col>
      </Row>
    </div>
  )
})
